import Event from '../Event';

export default class ExcelImportWrongFileLoaded extends Event {
    public static type = 'ExcelImportWrongFileLoaded';

    constructor() {
        super(ExcelImportWrongFileLoaded.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/core/events/ExcelImportWrongFileLoaded.ts